// @ts-nocheck
import {
  Info,
  InfoOutlined,
  Warning,
  WarningOutlined,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import PropTypes from "prop-types";

export default function InfoHover({ title, infoStyles, isBgFilled = false }) {
  return (
    <Tooltip arrow title={title}>
      {isBgFilled ? (
        <Info
          sx={{
            fontSize: "1rem",
            color: "white",
            cursor: "pointer",
            ...(infoStyles || {}),
          }}
        />
      ) : (
        <InfoOutlined
          sx={{
            fontSize: "1rem",
            color: "white",
            cursor: "pointer",
            ...(infoStyles || {}),
          }}
        />
      )}
    </Tooltip>
  );
}

InfoHover.propTypes = {
  title: PropTypes.string,
  infoStyles: PropTypes.any,
  isBgFilled: PropTypes.bool,
};

export function WarningHover({ title, infoStyles, isBgFilled = false }) {
  return (
    <Tooltip arrow title={title}>
      {isBgFilled ? (
        <Warning
          sx={{
            fontSize: "1rem",
            color: "#ffa726",
            cursor: "pointer",
            ...(infoStyles || {}),
          }}
        />
      ) : (
        <WarningOutlined
          sx={{
            fontSize: "1rem",
            color: "#ffa726",
            cursor: "pointer",
            ...(infoStyles || {}),
          }}
        />
      )}
    </Tooltip>
  );
}

WarningHover.propTypes = {
  title: PropTypes.string,
  infoStyles: PropTypes.any,
  isBgFilled: PropTypes.bool,
};